import { CategoryItem, ProductDropdownItem, ProductEntity, ProductItem, VariantUpdate } from '@models';
import { Observable } from 'rxjs';
import { DataGetFn, DataGetOptions, ItemRecord } from '@controladad/ng-base';
import { Injectable } from '@angular/core';
import { AdminProductsApiService } from './admin-products-api.service';
import { VendorProductsApiService } from './vendor-products-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProductApiServiceFactory {
  getProductApiService(isAdmin: boolean): IProductApiService {
    if (isAdmin) {
      return new AdminProductsApiService();
    } else {
      return new VendorProductsApiService();
    }
  }
}

export abstract class IProductApiService {
  abstract get(id: number): Observable<ProductEntity>;

  abstract getAdapter(options?: DataGetOptions<ProductItem>): DataGetFn<ProductItem>;

  abstract create(model: object): Observable<object>;

  abstract update(model: object): Observable<object>;

  abstract delete(ids: number[]): Observable<object>;

  abstract addVariants(data: { productId: number; variants: VariantUpdate[] }): Observable<object>;

  abstract deleteVariants(variantIds: number[]): Observable<object>;

  abstract changeStatus(enable: boolean, ids: number[]): Observable<object>;

  abstract changeApproval(approved: boolean, ids: number[]): Observable<object>;

  abstract getAllVendors(): Observable<ItemRecord<number>[]>;

  abstract getBrandItems(): Observable<ItemRecord<number>[]>;

  abstract getAttributeItemRecords(categoryIds: number[]): Observable<ItemRecord<number>[]>;

  abstract getAttributeTermItemRecords(id: number): Observable<ItemRecord<number>[]>;

  abstract getCategories(): Observable<CategoryItem[]>;

  abstract getProductNamesAdapter(options?: DataGetOptions<ProductDropdownItem>): DataGetFn<ProductDropdownItem>;

  abstract getProductDropdownItems(productIds: number[]): Observable<ProductDropdownItem[]>;

  abstract exportProducts(filters?: any): Observable<Blob>;
}